import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Brain } from 'lucide-react';

const sentimentLabel = (score) => {
  if (score > 0.1) return { label: 'Bullish', cls: 'bg-green-600' };
  if (score < -0.1) return { label: 'Bearish', cls: 'bg-red-600' };
  return { label: 'Neutral', cls: 'bg-yellow-500' };
};

const SentimentCard = ({ sentiment, stockData }) => {
  if (sentiment && sentiment.available) {
    const { label, cls } = sentimentLabel(sentiment.sentiment_score);
    return (
      <Card className="hover:shadow-lg transition-shadow" data-testid="research-sentiment-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg">
            <Brain className="text-purple-600" size={20} />
            News Sentiment
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="text-center mb-3">
              <Badge className={`text-base px-4 py-1.5 ${cls} text-white`}>{label}</Badge>
            </div>
            <div className="grid grid-cols-3 gap-2 text-sm">
              <div className="bg-green-50 p-2 rounded text-center">
                <div className="font-bold text-green-700">{sentiment.positive}%</div>
                <div className="text-xs text-green-600">Bullish</div>
              </div>
              <div className="bg-gray-100 p-2 rounded text-center">
                <div className="font-bold text-gray-700">{sentiment.neutral}%</div>
                <div className="text-xs text-gray-600">Neutral</div>
              </div>
              <div className="bg-red-50 p-2 rounded text-center">
                <div className="font-bold text-red-700">{sentiment.negative}%</div>
                <div className="text-xs text-red-600">Bearish</div>
              </div>
            </div>
            {sentiment.buzz?.articles_week > 0 && (
              <p className="text-xs text-gray-500 text-center mt-2">
                {sentiment.buzz.articles_week} articles this week
              </p>
            )}
          </div>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className="hover:shadow-lg transition-shadow" data-testid="research-sentiment-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Brain className="text-purple-600" size={20} />
          News Sentiment
        </CardTitle>
      </CardHeader>
      <CardContent>
        {stockData ? (
          <div className="text-center py-4">
            <p className="text-gray-500 text-sm">Sentiment data unavailable for this symbol</p>
            <p className="text-xs text-gray-400 mt-1">(Finnhub free tier limitation)</p>
          </div>
        ) : (
          <p className="text-gray-500 text-sm">Search for a stock to see news sentiment</p>
        )}
      </CardContent>
    </Card>
  );
};

export default SentimentCard;
